import React from 'react';

const DetailsViewIcon = (props: any) => {
  return (
    <svg width="30" height="30" viewBox="0 0 24 24" fill="currentColor" {...props}>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M11.9999 18C16.7069 18 19.7439 12.716 19.8709 12.492C20.0419 12.188 20.0429 11.816 19.8719 11.512C19.7459 11.287 16.7309 6 11.9999 6C7.24488 6 4.25088 11.289 4.12588 11.514C3.95688 11.817 3.95788 12.186 4.12788 12.489C4.25388 12.713 7.26888 18 11.9999 18ZM11.9999 8C14.8389 8 17.0359 10.835 17.8179 12C17.0339 13.166 14.8369 16 11.9999 16C9.15888 16 6.96188 13.162 6.18088 11.999C6.95788 10.835 9.14588 8 11.9999 8ZM11.9999 14C13.1045 14 13.9999 13.1046 13.9999 12C13.9999 10.8954 13.1045 10 11.9999 10C10.8953 10 9.99988 10.8954 9.99988 12C9.99988 13.1046 10.8953 14 11.9999 14Z"
      />
    </svg>
  );
};

export default DetailsViewIcon;
